import { render } from "./PreavisConsultModal.vue?vue&type=template&id=193139c4&scoped=true&ts=true"
import script from "./PreavisConsultModal.vue?vue&type=script&lang=ts"
export * from "./PreavisConsultModal.vue?vue&type=script&lang=ts"

import "./PreavisConsultModal.vue?vue&type=style&index=0&id=193139c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193139c4"]])

export default __exports__